<form [formGroup]="form">
  <div class="my-3 my-md-5 border rounded-3 shadow bg-light">
    <div class="row p-3 g-4">
      <div class="col-12 col-md-4">
        <span class="form-label">Област*</span>
        <ng-select
          [items]="regions"
          bindValue="regionId"
          bindLabel="regionName"
          formControlName="regionId"
          notFoundText="Няма намерени области"
          placeholder="Изберете област"
          (change)="onChangeRegionId($event)"
          [class.is-valid]="regionId?.touched && regionId?.valid"
          [class.is-invalid]="regionId?.touched && regionId?.invalid">
        </ng-select>
        @if (regionId?.touched && regionId?.invalid) {
          <p class="m-0 invalid-feedback">Задължително поле!</p>
        }
      </div>
      <div class="col-12 col-md-4">
        <span class="form-label">Община*</span>
        <ng-select
          [items]="municipalities"
          bindValue="municipalityId"
          bindLabel="municipalityName"
          formControlName="municipalityId"
          notFoundText="Няма намерени общини"
          placeholder="Изберете община"
          (change)="onChangeMunicipalityId($event)"
          [class.is-valid]="municipalityId?.touched && municipalityId?.valid"
          [class.is-invalid]="municipalityId?.touched && municipalityId?.invalid">
        </ng-select>
        @if (municipalityId?.touched && municipalityId?.invalid) {
          <p class="m-0 invalid-feedback">Задължително поле!</p>
        }
      </div>
      <div class="col-12 col-md-4">
        <span class="form-label">Населено място*</span>
        <ng-select
          [items]="populatedPlaces"
          bindValue="populatedPlaceId"
          bindLabel="populatedPlaceName"
          formControlName="populatedPlaceId"
          notFoundText="Няма намерени населени мяста"
          placeholder="Изберете населено място"
          [class.is-valid]="populatedPlaceId?.touched && populatedPlaceId?.valid"
          [class.is-invalid]="populatedPlaceId?.touched && populatedPlaceId?.invalid">
        </ng-select>
        @if (populatedPlaceId?.touched && populatedPlaceId?.invalid) {
          <p class="m-0 invalid-feedback">Задължително поле!</p>
        }
      </div>
      <div class="col-12">
        <div class="form-check">
          <input
            type="checkbox"
            id="isUserDefaultAddress"
            class="form-check-input"
            formControlName="isUserDefaultAddress">
          <label for="isUserDefaultAddress" class="form-check-label">
            Запази като адрес по подразбиране.
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="my-3 my-md-5 border rounded-3 shadow bg-light">
    <div class="row p-3 g-4">
      <div class="col-12 col-md-6">
        <label class="mb-1 form-label">Начин на плащане от купувача:</label>
        @for (paymentOption of adPaymentOptions; track paymentOption.adPaymentOptionId) {
          <div class="mb-2 form-check">
            <input
              type="checkbox"
              class="form-check-input"
              [id]="'paymentOption' + paymentOption.adPaymentOptionId"
              (click)="togglePaymentOption(paymentOption.adPaymentOptionId)"
              [checked]="adSelectedPaymentOptionIds.includes(paymentOption.adPaymentOptionId)">
            <label [for]="'paymentOption' + paymentOption.adPaymentOptionId" class="form-check-label">
              {{ paymentOption.adPaymentOptionName }}
            </label>
          </div>
        }
      </div>
      <div class="col-12 col-md-6">
        <label class="mb-1 form-label">Начин на доставка на артикула:</label>
        @for (deliveryOption of adDeliveryOptions; track deliveryOption.adDeliveryOptionId) {
          <div class="mb-2 form-check">
            <input
              type="checkbox"
              class="form-check-input"
              [id]="'deliveryOption' + deliveryOption.adDeliveryOptionId"
              (click)="toggleDeliveryOption(deliveryOption.adDeliveryOptionId)"
              [checked]="adSelectedDeliveryOptionIds.includes(deliveryOption.adDeliveryOptionId)">
            <label [for]="'deliveryOption' + deliveryOption.adDeliveryOptionId" class="form-check-label">
              {{ deliveryOption.adDeliveryOptionName }}
            </label>
          </div>
        }
      </div>
      <div class="col-12">
        <label for="paymentAndDeliveryInfo" class="mb-0 form-label">Допълнително информация за плащането и
          доставката</label>
        <textarea
          rows="3"
          id="paymentAndDeliveryInfo"
          maxlength="1000"
          class="form-control"
          formControlName="paymentAndDeliveryInfo"
          placeholder="Въведете допълнителна информация до 1000 символа за плащането и доставката..."></textarea>
      </div>
    </div>
  </div>
  <div class="my-3 my-md-5 border rounded-3 shadow bg-light">
    <div class="row p-3 g-4">
      <div class="col-12">
        <label for="additionalAdInfo" class="mb-0 form-label">Допълнителна информация за артикула</label>
        <textarea
          rows="3"
          id="additionalAdInfo"
          maxlength="1000"
          class="form-control"
          formControlName="additionalAdInfo"
          placeholder="Въведете допълнителна информация до 1000 символа за артикула..."></textarea>
      </div>
    </div>
  </div>
</form>
